const Constants = {
    ENDPOINTS: {
        LOGIN: "/login",
        PASSWORD_RECOVERY: "/passwordrecovery",
        PASSWORD_RESET: "/passwordreset",
        HOME: "/",
        KITS: "/kits-shop",
        BUILD_A_KIT: "/kits-build",
        KITS_DETAILS: "/kits/details",
        RENTALS: "/rentals",
        RENTALS_DETAILS: "/rentals/details",
        DEVICES: "/devices",
        DEVICES_DETAILS: "/devices/details",
        VTRACK: "/vtrack",
        LINEHAUL: "/line-haul",
        FEATURED_PRODUCTS: "/featured-products",
        VTRACK_DETAILS: "/vtrack/details",
        LINEHAUL_DETAILS: "/line-haul/details",
        ZEBRA_ACCESSORIES: "/accessories-zebra",
        ZEBRA_TC26_ACCESSORIES: "/accessories-tc26",
        ZEBRA_TC58_ACCESSORIES: "/zebra-tc58-accessories",
        ZEBRA_TC78_ACCESSORIES: "/zebra-tc78-accessories",
        PANASONIC_ACCESSORIES: "/accessories-panasonic",
        PANASONIC_T1_ACCESSORIES: "/panasonic-t1-accessories",
        SAMSUNG_ACCESSORIES: "/accessories-samsung",
        UNIVERSAL_ACCESSORIES: "/accessories-universal",
        ZEBRA_DETAILS: "/accessories-zebra/details",
        ZEBRA_TC26_DETAILS: "/accessories-tc26/details",
        ZEBRA_TC58_DETAILS: "/zebra-tc58-accessories/details",
        ZEBRA_TC78_DETAILS: "/zebra-tc78-accessories/details",
        PANASONIC_DETAILS: "/accessories-panasonic/details",
        PANASONIC_T1_DETAILS: "/panasonic-t1-accessories/details",
        SAMSUNG_DETAILS: "/accessories-samsung/details",
        UNIVERSAL_DETAILS: "/accessories-universal/details",
        DEVICE_COMPARISON: "/device-comparison",
        SERVICES: "/about/services",
        COMPANY: "/about/company",
        SUPPORT: "/support-contact",
        PRIVACY_POLICY: "/support/privacypolicy",
        RETURN_REFUND_POLICY: "/support/returnrefundpolicy",
        ADVANCED_EXCHANGE: "/support/pending-returns",
        BUYING_GUIDE: "/BuyingGuide",
        PAYMENT_OPTIONS: "/PaymentOptions",
        CART: "/cart",
        PAY_IN_FULL_CHECKOUT: "/checkout",
        LEASE_APPLICATION: "/applyforlease",
        LEASE_CHECKOUT: "/lease",
        ORDER_CONFIRMATION: "/ordercomplete",
        CUSTOMER: "/customer",
        CUSTOMER_INFO: "/customer/info",
        CUSTOMER_ADDRESSES: "/customer/addresses",
        CUSTOMER_ORDERS: "/customer/orders",
        CUSTOMER_CHANGE_PASSWORD: "/customer/changepassword",
        LEASING_FAQS: "/leasingfaqs"
    },
    FETCH_REQUEST_CONFIG: {
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    },
    DEFAULT_LANGUAGE: {
        languageId: 1,
        flag: "us",
        code: "en-US"
    },
    DEFAULT_CURRENCY: {
        id: 1,
        name: "US Dollar",
        currencyCode: "USD",
        rate: 1
    }
};

export default Constants;